

import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, Link } from "react-router-dom";


import {
    fetchGalleryImageUpdate,
    getPackageDeginationsbyId,
    updatePackageDeginations,
    packageDeginationsAdd
} from "../../services/userservice";

import {
    setLoading,
    setError,
    setEditingPackageDeginationId,
    setEditingPackageDegination,
} from "../../features/common/packageDeginationSlice";

const Adddestination = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isEditMode, setIsEditMode] = useState(false);
    const { loading, error, packageDeginationToEdit, editingPackageDegination } = useSelector(
        (state) => state.packageDegination
    );

    const [formData, setFormData] = useState({
        name: "",
        image_url: [],
        status: "",
    });

    const [imageURL, setImageURL] = useState(formData?.image_url)

    console.log("imageURL", imageURL)

    useEffect(() => {
        if (id && id !== "add" && packageDeginationToEdit !== id) {
            dispatch(setLoading());
            dispatch(setEditingPackageDeginationId(id));
            dispatch(setEditingPackageDegination(id));
            fetchUserData(id);
        }
    }, [id, packageDeginationToEdit, dispatch]);


    const fetchUserData = async (id) => {
        try {
            dispatch(setLoading());
            const response = await getPackageDeginationsbyId(id);
            if (response) {
                const responseData = response;
                console.log("responseData,", responseData?.image_url)
                setFormData({
                    name: responseData?.name,
                    image_url: responseData?.image_url || [],
                    status: responseData?.status
                });
                setImageURL(responseData?.image_url || [])
                dispatch(setLoading(false));
            }
        } catch (error) {
            dispatch(setError(error.message));
        } finally {
            dispatch(setLoading(false));
        }
    };

    console.log("formData?.image_url", formData?.image_url)

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const formDataToSend = {
                ...formData,
                image_url: imageURL?.[0]?.image_url,
                thumbnail_image_url: imageURL?.[0]?.thumbnail_image_url,
            };

            dispatch(setLoading(true));
            const response =
                id && id !== "add"
                    ? await updatePackageDeginations(id, formDataToSend)
                    : await packageDeginationsAdd(formDataToSend);
            navigate("/destination-list");
            console.log("response", response)
        } catch (error) {
            dispatch(setError(error.message));
            alert(error.message);

            dispatch(setLoading(false));
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };



    useEffect(() => {
        if (Array.isArray(formData.image_url)) {
            setImageURL(formData.image_url);
        }
    }, [formData.image_url]);


    // const handleGalleryChange = async (e) => {
    //     const files = Array.from(e.target.files);
    //     const formData = new FormData();

    //     files.forEach((file) => {
    //         formData.append('profile_pic', file);
    //         formData.append('type', "banner");
    //     });

    //     try {
    //         const response = await fetchGalleryImageUpdate(formData);
    //         setImageURL(response?.data?.files)
    //     } catch (error) {
    //         console.error("Error uploading image:", error);
    //     }
    // };




    const handleGalleryChange = async (e) => {
        const files = Array.from(e.target.files);
        const formData = new FormData();

        files.forEach((file) => {
            formData.append("profile_pic", file);
            formData.append("type", "banner");
        });

        try {
            const response = await fetchGalleryImageUpdate(formData);
            if (response?.data?.files) {
                setImageURL(response.data.files);
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    image_url: response?.data?.files?.[0]?.image_url,
                }));
            }
        } catch (error) {
            console.error("Error uploading image:", error);
        }
    };

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Add Destination   </h1>
                        </div>
                        {/* /.col */}
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item active">Destination</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div classname="row">
                        <div classname="col-md-12">
                            <form onSubmit={handleSubmit}>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Destination</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="exampleInputEmail1"
                                                        placeholder="Enter Destination"
                                                        name="name"
                                                        value={formData.name}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label>STATUS</label>
                                                    <select
                                                        className="form-control"
                                                        id="status"
                                                        name="status"
                                                        value={formData.status}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="active">ACTIVE</option>
                                                        <option value="inactive">INACTIVE</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-sm-12">
                                                <div className="form-group">
                                                    <label>Image (Upload Images)</label>
                                                    <input
                                                        type="file"
                                                        multiple
                                                        className="form-control"
                                                        onChange={handleGalleryChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                {imageURL && imageURL?.length > 0 && (
                                                    <>
                                                        <label>Uploaded Image</label>
                                                        <br />
                                                        <img
                                                            src={imageURL?.[0]?.image_url || imageURL}
                                                            alt="Uploaded Preview"
                                                            style={{ width: "100%", borderRadius: "10px" }}
                                                        />
                                                    </>
                                                )}
                                            </div>

                                        </div>

                                    </div>
                                    <div className="card-footer">
                                        <button type="submit" className="btn btn-primary">
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Adddestination;
